/**
 * Invoice – L'Invoice project translations (translation namespace only)
 * Detailed invoice UI uses namespace 'einvoice'
 */

import menu from "./menu.js";

export default {
  ...menu,
};
